import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { Button, Container, Dropdown, Header, Input, Tab } from 'semantic-ui-react';
import { ALL_AREAS } from '..';
import { sysAPI } from '../../../apis/SysAPI';
import { useDispatch } from 'react-redux';
import { responseError } from '../../../helpers';
import RaisedFlags from './Tables/RaisedFlags';
import LoaderCustom from '../../../components/tabs/EstateManualInputRequestsTab/LoaderCustom';
import HistoricProspectConversion from './Prospects/HistoricProspectConversion';
import ProspectActivity from './Prospects/ProspectActivity';
import ActivityPeriod from './Usage/ActivityPeriod';
import WeekUserAcvitityByArea from './Usage/WeekUserAcvitityByArea';
import PaidAndTrialsTable from './Usage/PaidAndTrialsTable';
import GraphicValidVsInvalid from './Tables/GraphicValidVsInvalid';
import TypeOfAnalysis from './Tables/TypeOfAnalysis';
import AverageProcessingTime from './Tables/AverageProcessingTime';
import ReturnFlags from './Tables/ReturnFlags';
import ReasonOfFailure from './Tables/ReasonOfFailure';

const GraphicsV2 = () => {
    const dispatch = useDispatch();
    const [startDate, setStartDate] = useState(moment().subtract(1, 'month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [areas, setAreas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [excludeCompanies, setExcludeCompanies] = useState([]);
    const [includeCompanies, setIncludeCompanies] = useState([]);
    const [companiesList, setCompaniesList] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    const refUsageWeekUserActivityByArea = useRef();
    const refUsagePaidAndTrialsTable = useRef();
    const refUsageActivityPeriod = useRef();
    const refTableTypeOfAnalysis = useRef();
    const refTableAverageProcessingTime = useRef();
    const refTableReturnFlags = useRef();
    const refTableReasonOfFailure = useRef();
    const refTableRaisedFlag = useRef();
    const refTableGraphicValidVsInvalid = useRef();
    const refTableHistoricProspectConversion = useRef();
    const refTableProspectActivity = useRef();

    const areasOption = Object.keys(ALL_AREAS).map((area) => {
        return { key: area, text: ALL_AREAS[area], value: area };
    });

    const ejecutarFunction = () => {
        if (refUsagePaidAndTrialsTable.current) {
            refUsagePaidAndTrialsTable.current.getData();
        }
        if (refUsageWeekUserActivityByArea.current) {
            refUsageWeekUserActivityByArea.current.getData();
        }
        if (refUsageActivityPeriod.current) {
            refUsageActivityPeriod.current.getData();
        }
        if (refTableGraphicValidVsInvalid.current) {
            refTableGraphicValidVsInvalid.current.getData();
        }
        if (refTableTypeOfAnalysis.current) {
            refTableTypeOfAnalysis.current.getData();
        }
        if (refTableReturnFlags.current) {
            refTableReturnFlags.current.getData();
        }
        if (refTableAverageProcessingTime.current) {
            refTableAverageProcessingTime.current.getData();
        }
        if (refTableReasonOfFailure.current) {
            refTableReasonOfFailure.current.getData();
        }
        if (refTableRaisedFlag.current) {
            refTableRaisedFlag.current.getData();
        }
        if (refTableHistoricProspectConversion.current) {
            refTableHistoricProspectConversion.current.getData();
        }
        if (refTableProspectActivity.current) {
            refTableProspectActivity.current.getData();
        }
    };
    const handleChange = (e, data) => {
        setActiveIndex(data.activeIndex);
    };

    const getCompanies = async () => {
        try {
            const { data } = await sysAPI.get(`/companies`);
            setCompaniesList(data.companies.map((company) => ({ key: company._id, text: company.name, value: company._id })));
        } catch (error) {
            responseError(error, undefined, 'GraphicsV2.getCompanies', dispatch);
        }
    };

    useEffect(() => {
        getCompanies();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const panes = [
        {
            menuItem: 'Usage',
            render: () => (
                <Tab.Pane>
                    <div style={{marginBottom:"20px"}}>
                        <Header textAlign="center" as="h2">
                            Usage
                        </Header>
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        <ActivityPeriod
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refUsageActivityPeriod}
                        />
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        <WeekUserAcvitityByArea
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refUsageWeekUserActivityByArea}
                        />
                    </div>
                    <div>
                        <PaidAndTrialsTable
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refUsagePaidAndTrialsTable}
                        />
                    </div>
                </Tab.Pane>
            ),
        },
        {
            menuItem: 'Tables',
            render: () => (
                <Tab.Pane>
                    <div style={{marginBottom:"20px"}}>
                        <Header textAlign="center" as="h2">
                            Tables
                        </Header>
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        <GraphicValidVsInvalid
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refTableGraphicValidVsInvalid}
                        />
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        <TypeOfAnalysis
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refTableTypeOfAnalysis}
                        />
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        <AverageProcessingTime
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refTableAverageProcessingTime}
                        />
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        <ReturnFlags
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refTableReturnFlags}
                        />
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        <ReasonOfFailure
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refTableReasonOfFailure}
                        />
                    </div>
                    <div>
                        <RaisedFlags
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refTableRaisedFlag}
                        />
                    </div>
                </Tab.Pane>
            ),
        },
        {
            menuItem: 'Propects',
            render: () => (
                <Tab.Pane>
                    <div style={{marginBottom:"20px"}}>
                        <Header textAlign="center" as="h2">
                            Prospects
                        </Header>
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        <HistoricProspectConversion
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refTableHistoricProspectConversion}
                        />
                    </div>
                    <div style={{marginBottom:"10px"}}>
                        <ProspectActivity
                            activeIndex={activeIndex}
                            startDate={startDate}
                            endDate={endDate}
                            areas={areas}
                            loading={loading}
                            setLoading={setLoading}
                            excludeCompanies={excludeCompanies}
                            includeCompanies={includeCompanies}
                            ref={refTableProspectActivity}
                        />
                    </div>
                </Tab.Pane>
            ),
        }
    ];

    return (
        <>
            <Container fluid>
                <div>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <div>
                            <Input label="From" type="date" value={startDate} onChange={(e) => setStartDate(e.currentTarget.value)} />
                        </div>
                        <div>
                            <Input label="To" type="date" value={endDate} onChange={(e) => setEndDate(e.currentTarget.value)} />
                        </div>
                        <div>
                            <Dropdown
                                placeholder="Inlcude Company"
                                multiple
                                selection
                                options={companiesList}
                                value={includeCompanies || []}
                                onChange={(e, { value }) => setIncludeCompanies(value)}
                            />
                        </div>
                        <div>
                            <Dropdown
                                placeholder="Exclude Company"
                                multiple
                                selection
                                options={companiesList}
                                value={excludeCompanies || []}
                                onChange={(e, { value }) => setExcludeCompanies(value)}
                            />
                        </div>
                        <div>
                            <Dropdown
                                placeholder="Areas"
                                multiple
                                selection
                                options={areasOption}
                                value={areas || []}
                                onChange={(e, { value }) => setAreas(value)}
                            />
                        </div>
                        <div>
                            <Button loading={loading} style={{ marginLeft: '10px' }} color="grey" onClick={() => ejecutarFunction()}>
                                Filter
                            </Button>
                        </div>
                    </div>
                </div>
                <div>
                    <Tab menu={{ pointing: true, secondary: true }} panes={panes} onTabChange={handleChange} />
                </div>
                {loading && <LoaderCustom />}
            </Container>
        </>
    );
};
export default GraphicsV2;
